/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Client } from '../../models/client';
import { ClientCreateRequest } from '../../models/client-create-request';
import { KeyType } from '../../models/key-type';

export interface CreateClient$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
      body: ClientCreateRequest
}

export function createClient(http: HttpClient, rootUrl: string, params: CreateClient$Params, context?: HttpContext): Observable<StrictHttpResponse<Client>> {
  const rb = new RequestBuilder(rootUrl, createClient.PATH, 'post');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Client>;
    })
  );
}

createClient.PATH = '/administration/organizations/{organizationKey}/clients';
